import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=44383843"
import script from "./fullscreen.vue?vue&type=script&lang=ts"
export * from "./fullscreen.vue?vue&type=script&lang=ts"
import style0 from "./fullscreen.vue?vue&type=style&index=0&id=44383843&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports